module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_9006.ba7287c6.png";